import React from 'react';
import "./ProductsCard.css";
import { Link } from 'react-router-dom';


const ProductsCard = (props) => {
const productURL = `/product/${props.product.alias.alias}/${props.id}`;

    return (  
        <div className="card-container_" style={{border:"none"}}>
            <div className="card u-clearfix_" style={{flexDirection:"row", height:"100%", minHeight: '400px', border:"none"}}>
                <div className="card-body_">
                    {/* <span className="card-number_ card-circle_ subtle_">{props.num+1}</span> */}
                    <span className="card-author_ subtle_">{props.title}</span>
                    <span className="card-description_ subtle_" dangerouslySetInnerHTML={{__html: props.product.productAdvantageList.contentItems.filter(i=> i.__typename !== 'LabelForAdvantage')[0].htmlBody.html}}/>
                    <Link to={`${process.env.PUBLIC_URL + productURL}`}>
                        <span className="card-tag_ subtle_ readMoreBtn">بیشتر بخوانید...</span>
                    </Link>
                        
                </div>
                <div className="card-media_">
                    <Link to={`${process.env.PUBLIC_URL + productURL}`}>
                        <img src={process.env.REACT_APP_BASE_URL+"/media/Poducts/" + props.title + ".jpg"} alt="" />
                    </Link>
                </div>
            </div>
            <div className="card-shadow_"></div>
        </div>
    );
}
 
export default ProductsCard;